
import React from 'react'

import http from '../../../lib/http'
import { AutoComplete } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

const dataFunc = text => {
  if (text && text.length > 0) {
    return new Promise(resolve => {
      const search = { text }
      http
        .getRequest(encodeURI('/terminology/icd10/lookup'), search)
        .then(terms => {
          if (terms.length === 0) {
            resolve('Sorry, no results found.')
          } else {
            resolve(terms)
          }
        })
        .catch(() => {
          resolve('Please enter more search criteria')
        })
    })
  }
  return Promise.resolve('Please enter search criteria for Icd10 Codes')
}

const textFunc = obj => obj.display

const displayFunc = obj => [
  obj.text || obj.display,
  <div
    key={1}
    className='nh-info'
  >
    {obj.code}
  </div>
]

class Icd10AutocompleteField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.handle = this.handle.bind(this)
  }

  handle (v) {
    const { onChange } = this.props
    if (onChange) {
      onChange(v)
    }
  }

  render () {
    const { label, value, ...rest } = this.props
    return (
      <AutoComplete
        {...rest}
        label={label || 'Diagnosis'}
        dataFunc={dataFunc}
        textFunc={textFunc}
        displayFunc={displayFunc}
        value={value}
        onChange={this.handle}
      />
    )
  }
}

export const Icd10AutocompleteInput = makeAutobindedInput(
  Icd10AutocompleteField
)
